import { render } from "./InputVideo.vue?vue&type=template&id=c253c22a"
import script from "./InputVideo.vue?vue&type=script&lang=js"
export * from "./InputVideo.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/popinsight-tools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__